import { useState } from "react";

// import { Switch } from "@mui/base/Switch";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pt-br";
import styles from "./styles.module.scss";
import ArrowIconLeft from "./../../../../assets/_ArrowIconLeft_.svg";
import ArrowIconRight from "./../../../../assets/_ArrowIconRight_.svg";
import { calculateTimeRange } from "../../../../utils/timeUtils";
import { IReportMetricsRow } from "../../../../@types/reports-metrics.type";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

dayjs.extend(quarterOfYear);
dayjs.extend(localizedFormat);
dayjs.locale("pt-br"); // Define o idioma para português

interface DefaultFilterReportProps {
  onFilterChange: (
    timeMode: number,
    period: string,
    currentPeriod: dayjs.Dayjs
  ) => void;
  rowSelected: IReportMetricsRow | null;
}

export const DefaultFilterReport: React.FC<DefaultFilterReportProps> = ({
  onFilterChange,
  rowSelected = null,
}) => {
  const [timeMode, setTimeMode] = useState(1);
  const [period, setPeriod] = useState("Mensal");
  const [currentPeriod, setCurrentPeriod] = useState(dayjs());

  const getLabelValue = () => {
    const { startDate, endDate } = calculateTimeRange(currentPeriod, period);

    const startFormatted = startDate.format("DD MMM").split(" ");
    startFormatted[1] =
      startFormatted[1].charAt(0).toUpperCase() + startFormatted[1].slice(1);

    const endFormatted = endDate.format("DD MMM YYYY").split(" ");
    endFormatted[1] =
      endFormatted[1].charAt(0).toUpperCase() + endFormatted[1].slice(1);

    return `${startFormatted.join(" ")} - ${endFormatted.join(" ")}`;
  };

  // Atualize os valores do estado e chame a função de callback
  const handleTimeModeChange = (event) => {
    const newTimeMode = event.target.checked ? 1 : 0;
    setTimeMode(newTimeMode);
    onFilterChange(newTimeMode, period, currentPeriod); // Notifica o componente pai
  };

  const handlePeriodChange = (event) => {
    const newPeriod = event.target.value;
    setPeriod(newPeriod);
    setCurrentPeriod(dayjs());
    onFilterChange(timeMode, newPeriod, dayjs()); // Notifica o componente pai
  };

  const handlePrevious = () => {
    let newPeriod;
    switch (period) {
      case "Semanal":
        newPeriod = currentPeriod.subtract(1, "week");
        break;
      case "Mensal":
        newPeriod = currentPeriod.subtract(1, "month");
        break;
      case "Trimestral":
        newPeriod = currentPeriod.subtract(1, "quarter");
        break;
      case "Semestral":
        newPeriod = currentPeriod.subtract(6, "months");
        break;
      case "Anual":
        newPeriod = currentPeriod.subtract(1, "year");
        break;
      default:
        newPeriod = currentPeriod.subtract(1, "week");
    }
    setCurrentPeriod(newPeriod);
    onFilterChange(timeMode, period, newPeriod); // Notifica o componente pai
  };

  const handleNext = () => {
    let newPeriod;
    switch (period) {
      case "Semanal":
        newPeriod = currentPeriod.add(1, "week");
        break;
      case "Mensal":
        newPeriod = currentPeriod.add(1, "month");
        break;
      case "Trimestral":
        newPeriod = currentPeriod.add(1, "quarter");
        break;
      case "Semestral":
        newPeriod = currentPeriod.add(6, "months");
        break;
      case "Anual":
        newPeriod = currentPeriod.add(1, "year");
        break;
      default:
        newPeriod = currentPeriod.add(1, "week");
    }
    setCurrentPeriod(newPeriod);
    onFilterChange(timeMode, period, newPeriod); // Notifica o componente pai
  };

  return (
    <div className={styles.filterContainer}>
      {rowSelected && (
        <h3 title={rowSelected.name}>{rowSelected.name}</h3>
      )}
      <div className={styles.switchSelect}>
        {/* <div className={styles.switch}>
          <span
            className={`${styles.switchLabel} ${
              timeMode === 0 ? styles.activeLabel : ""
            }`}
          >
            Dia
          </span>
          <Switch
            className={styles.switchRoot}
            checked={timeMode === 1}
            onChange={handleTimeModeChange}
          />
          <span
            className={`${styles.switchLabel} ${
              timeMode === 1 ? styles.activeLabel : ""
            }`}
          >
            Hora
          </span>
        </div> */}
        {/* <div className={styles.column}>
          <div className={styles.columnSeparator} />
        </div> */}
        <Select
          className={styles.filterSelect}
          sx={{ m: 1, minWidth: 120 }}
          value={period}
          onChange={handlePeriodChange}
          variant="standard"
        >
          <MenuItem value="Semanal">Semanal</MenuItem>
          <MenuItem value="Mensal">Mensal</MenuItem>
          <MenuItem value="Trimestral">Trimestral</MenuItem>
          <MenuItem value="Semestral">Semestral</MenuItem>
          <MenuItem value="Anual">Anual</MenuItem>
        </Select>
      </div>
      <div className={styles.divButton}>
        <Button onClick={handlePrevious} className={styles.button}>
          <img src={ArrowIconLeft} className={styles.buttonLeft} />
        </Button>
        <div className={styles.getLabel}>{getLabelValue()}</div>
        <Button onClick={handleNext} className={styles.button}>
          <img src={ArrowIconRight} className={styles.buttonRight} />
        </Button>
      </div>
    </div>
  );
};
